<template>
<v-row>
  <v-col cols="12">
    <v-skeleton-loader
      ref="skeleton"
      v-if="!showPage"
      type="card"
      class="mx-auto"
    ></v-skeleton-loader>
    <v-row dense align="center" v-if="showPage">
      <v-col cols="12">
        <v-row>
          <v-col cols="3">
            <h3>{{ form.domain }}</h3>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="3">
            <h5>Status:<br>{{ form.status_name }}</h5>
          </v-col>
          <v-col cols="3">
            <h5>Registration Date:<br>{{ form.provision_date }}</h5>
          </v-col>
          <v-col cols="3">
            <h5>Expiry Date:<br>{{ form.expiry_date }}</h5>
          </v-col>
          <v-col cols="3">
            <div class="my-1">
              <v-btn
                v-if="(form.status_name === 'Active'
            || form.status_name === 'Pending Renewal')"
                x-small
                color="success"
                @click="editDns(id)"
              >
                Edit DNS
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-form ref="updateNsForm">
        <v-row dense>
          <v-col cols="3">
            <v-text-field
              label="NS1*"
              v-model="form.ns1"
              :rules="[rules.required, rules.nameserver]"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="NS2*"
              v-model="form.ns2"
              :rules="[rules.required, rules.nameserver]"></v-text-field>
          </v-col>
        </v-row>
        <v-row dense align="center">
          <v-col cols="3">
            <v-text-field
              label="NS3"
              v-model="form.ns3"
              :rules="[rules.nameserver]"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="NS4"
              v-model="form.ns4"
              :rules="[rules.nameserver]"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="NS5"
              v-model="form.ns5"
              :rules="[rules.nameserver]"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-btn small color="primary"
              :loading="updateNsLoading"
              @click="updateNs"
            >Update Nameservers</v-btn>
          </v-col>
        </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-col>
</v-row>
</template>

<script>
export default {
  name: 'AgentDomainDetail',
  components: {
  },
  created() {
    this.id = +this.$route.params.id;
    this.reloadDomain();
  },
  data() {
    return {
      id: null,
      showPage: false,
      epp: null,
      form: {
        domain: '',
        product_id: null,
        product_term: null,
        status_name: '',
        tld: null,
        auto_renew: true,
        locked: true,
        ns1: '',
        ns2: '',
        ns3: '',
        ns4: '',
        ns5: '',
        provision_date: '',
        expiry_date: '',
        registrant: {},
        admin: {},
        tech: {},
        billing: {},
      },
      childNss: [],
      addChildNss: [],
      deleteChildNss: [],
      updateChildNss: [],
      domainDnssec: [],
      addDomainDnssec: [],
      defaultContact: null,
      registrant: null,
      admin: null,
      tech: null,
      billing: null,
      domainErr: null,
      tld_list: [],
      tldPriceList: [],
      terms: [],
      checkDomainLoading: false,
      checkDomainInvalid: true,
      checkoutProcessing: false,
      checkoutDisabled: false,
      showPriceTable: false,
      showRegistrationForm: false,
      eppLoading: false,
      autoRenewLoading: false,
      lockLoading: false,
      updateNsLoading: false,
      updateRegistrantLoading: false,
      updateAdminLoading: false,
      updateTechLoading: false,
      updateBillingLoading: false,
      updateChildNsLoading: false,
      renewDialog: false,
      renewLoading: false,
      renewCheckoutLoading: false,
      renewalTerms: [],
      renewalTerm: null,
      successMessage:
        'We are registering your domain now. '
        + 'An email will be sent to you when your service is ready.',
      valid: false,
      rules: {
        required: (value) => !!value || 'This field is required.',
        isNumeric: (value) => this.$underscore.isFinite(value) || 'This field must be numeric.',
        domain: (value) => (/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?/i).test(value) || 'This field must be valid domain name.',
        childNs: (value) => (/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i).test(`${value}.${this.form.domain}`) || this.$underscore.isEmpty(value) || 'This field must be valid hostname.',
        nameserver: (value) => (/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i).test(value) || this.$underscore.isEmpty(value) || 'This field must be valid hostname.',
        ip: (value) => (/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/).test(value) || 'This field must be valid IP.',
      },

      orderableProducts: [],
      addonData: null,
      serviceTermId: null,
      parentProductTerms: [],
      addonRegistrationComponentKey: 1,
      totalAddon: 0,
      buying: false,
      service: null,

      showServiceRenewDialog: false,
      renewServiceId: null,
      showServiceUpgradeDialog: false,
      upgradeServiceId: null,
      showServiceCancelDialog: false,
      cancelServiceId: null,
      cancelDialog: false,
      cancelLoading: false,
      cancelled: false,
      canEpp: false,
      canChangeOtherContact: false,
      canViewOtherContact: false,
      canChangeRegContact: false,
      canViewRegContact: false,
      updateDnssecLoading: false,
    };
  },
  methods: {
    reloadDomain() {
      this.$api.get(`agent/domain/${this.$route.params.id}?with_addon_info=1`).then((response) => {
        const domainData = response.data;
        this.serviceTermId = this.$gceCommon.getTermIdByTermMonth(domainData.service_month_term);
        this.service = domainData;
        this.form.domain = domainData.service_identity;
        this.form.product_id = domainData.product_id;
        const regD = domainData.provision_date.split(' ');
        const expD = domainData.expiry_date.split(' ');
        [this.form.provision_date] = regD;
        this.form.status_name = domainData.service_status_name;
        [this.form.expiry_date] = expD;
        this.form.auto_renew = domainData.auto_renew === 1;
        this.canEpp = domainData.domain_config.product_configuration.allow_directly_retrieve_epp;
        const registrarId = domainData.domain_config.service_configuration.registrar_id;
        if (registrarId === 7 || registrarId === 6) {
          this.canViewRegContact = true;
        }
        this.canViewRegContact = true;
        this.form.locked = domainData.domain_config.service_configuration.locked === 1;
        this.form.ns1 = domainData.domain_config.service_configuration.ns1;
        this.form.ns2 = domainData.domain_config.service_configuration.ns2;
        this.form.ns3 = domainData.domain_config.service_configuration.ns3;
        this.form.ns4 = domainData.domain_config.service_configuration.ns4;
        this.form.ns5 = domainData.domain_config.service_configuration.ns5;
        this.$set(this, 'registrant', domainData.domain_config.service_configuration.registrant);
        this.$set(this, 'admin', domainData.domain_config.service_configuration.admin);
        this.$set(this, 'tech', domainData.domain_config.service_configuration.tech);
        this.$set(this, 'billing', domainData.domain_config.service_configuration.billing);
        this.$set(this, 'addChildNss', []);
        this.$set(this, 'deleteChildNss', []);
        this.$set(this, 'childNss', domainData.domain_config.service_configuration.child_nameservers);
        this.showPage = true;
        this.$underscore.each(this.orderableProducts, (products) => {
          this.$underscore.each(products, (product) => {
            if (product.id === domainData.product_id) {
              this.$underscore.each(product.currencies, (value) => {
                const currentProductPrice = {
                  text: `${value.termName}: $${value.productPrice}`,
                  value: value.productTermId,
                  price: value.productPrice,
                };
                this.parentProductTerms.push(currentProductPrice.value);
              });
            }
          });
        });
      });
    },
    reset() {
      this.$router.go(0);
    },
    updateNs() {
      this.updateNsLoading = true;
      this.$api.post(`agent/domain/${this.$route.params.id}/update-nameservers`, {
        ns1: this.form.ns1,
        ns2: this.form.ns2,
        ns3: this.form.ns3,
        ns4: this.form.ns4,
        ns5: this.form.ns5,
      }).then(() => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'NS is updated successfully.',
        });
      }).finally(() => {
        this.updateNsLoading = false;
      });
    },
    editDns(did) {
      this.$router.push({ name: 'CpDnsEditor', params: { id: did } });
    },
  },
  watch: {
    'form.domain': {
      handler(domain) {
        if (this.rules.domain(domain) !== true) {
          this.checkDomainInvalid = true;
        } else {
          this.checkDomainInvalid = false;
          this.domainErr = null;
        }
      },
    },
  },
};
</script>

<style scoped>

</style>
